import { createContext } from "react";
var HasError = createContext({ hasError: false });
export default HasError;
